import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function AnexoIcon({
  size,
  style,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill: true });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      style={style}
      viewBox='0 0 17 17'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.2666 12.7273V3.54225C5.2666 0.28284 10.5288 0.282773 10.5288 3.54225C10.5288 5.91241 10.5288 10.6531 10.5288 13.32C10.5288 15.6902 6.91104 15.6902 6.91104 13.32C6.91104 11.542 6.91104 7.09745 6.91104 5.31989C6.91104 4.13448 8.88437 4.13448 8.88437 5.31989C8.88437 7.69005 8.88437 12.7273 8.88437 12.7273'
        stroke='currentColor'
        strokeLinejoin='round'
      />
    </svg>
  );
}
